export default __webpack_public_path__ + "static/media/sf-receivables.618173c7.png";